import { render } from "./TesteAxiosView.vue?vue&type=template&id=738c9d7c"
import script from "./TesteAxiosView.vue?vue&type=script&lang=js"
export * from "./TesteAxiosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__